import {DestinationQuery} from "@/components/private-routing-destination/queries.generated";
import {MutationUpdatePrivateRoutingDestinationsArgs} from "@/api";

export function createInitialData(destinations?: DestinationQuery): MutationUpdatePrivateRoutingDestinationsArgs {
    if (!destinations)
        return {
            destinations: [],
        };

    return {
        destinations: destinations.destination.items.map((dest) => ({
            id: dest.id,
            name: dest.name,
            numberingPlans: dest.numberingPlans.map((plan) => ({
                id: plan.id,
                prefix: plan.prefix,
            })),
        })),
    };
}
